import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CollapsibleAreaComponent } from './collapsible-area/collapsible-area.component';
import { CollapsibleBlockComponent } from './collapsible-block/collapsible-block.component';
import { CommonViewComponent } from './common-view/common-view.component';
import { SliderComponent } from './slider/slider.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { ControlsModule } from './controls/controls.module';
import { WidgetModule } from './widget/widget.module';
import { PipeModule } from '@app/system/pipes/pipe.module';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { StatsComponent } from './stats/stats.component';
import { ManageComponent } from './manage/manage.component';
import { CommonListComponent, ListItemsComponent } from './common-list/common-list.component';
import { PopupComponent } from './popup/popup.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { ShimmerComponent, ShimmerTransparent, ShimmerObstacle } from './shimmer/shimmer.component';
import { LoaderComponent } from './loader/loader.component';
import { ReadabilityComponent, ReadabilityContent } from './readability/readability.component';
import { FormGroupComponent } from './form-group/form-group.component';
import { FormComponent } from './form/form.component';
import { ChipsModule } from './chips/chips.module';
import { MatLegacyPaginatorModule as MatPaginatorModule } from '@angular/material/legacy-paginator';
import { BadgeModule } from './badge/badge.module';
import { ChartsModule } from './charts/charts.module';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatRippleModule } from '@angular/material/core';
import { DirectivesModule } from '@app/system/directives/directives.module';
import { AlertModule } from '@app/system/alert/alert.module';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';


@NgModule({
    declarations: [
        PopupComponent,
        SnackBarComponent,
        CollapsibleAreaComponent,
        CollapsibleBlockComponent,
        CommonViewComponent,
        SliderComponent,
        StatsComponent,
        ManageComponent,
        CommonListComponent,
        ListItemsComponent,
        VideoPlayerComponent,
        AudioPlayerComponent,
        ShimmerComponent,
        ShimmerTransparent,
        ShimmerObstacle,
        LoaderComponent,
        ReadabilityComponent,
        FormGroupComponent,
        FormComponent,
        ReadabilityContent,
        ProgressbarComponent
    ],
    imports: [
        CommonModule,
        MatIconModule,
        FlexLayoutModule,
        PipeModule,
        MatExpansionModule,
        WidgetModule,
        FormsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatTooltipModule,
        MatChipsModule,
        ControlsModule,
        ChipsModule,
        MatPaginatorModule,
        BadgeModule,
        ChartsModule,
        CarouselModule,
        MatProgressSpinnerModule,
        MatRippleModule,
        DirectivesModule,
        AlertModule,
        MatProgressBarModule
    ],
    exports: [
        SnackBarComponent,
        CollapsibleBlockComponent,
        CollapsibleAreaComponent,
        CommonViewComponent,
        SliderComponent,
        ControlsModule,
        WidgetModule,
        StatsComponent,
        ManageComponent,
        CommonListComponent,
        ListItemsComponent,
        VideoPlayerComponent,
        AudioPlayerComponent,
        ShimmerComponent,
        ShimmerTransparent,
        ShimmerObstacle,
        LoaderComponent,
        ReadabilityComponent,
        FormGroupComponent,
        FormComponent,
        ChipsModule,
        ReadabilityContent,
        BadgeModule,
        ChartsModule,
        ProgressbarComponent
    ],
    providers: []
})
export class ComponentsModule { }
